import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface ErrorFallbackScreenProps {
  onReset: () => void;
  variant?: 'fullscreen' | 'inline';
}

export function ErrorFallbackScreen({ onReset, variant = 'fullscreen' }: ErrorFallbackScreenProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <div
      className={`${variant === 'fullscreen' ? 'min-h-screen ' : ''}flex items-center justify-center bg-gray-50 px-4 py-8`}
    >
      <div className="bg-white border border-gray-200 rounded-lg p-6 max-w-md w-full text-center">
        <h2 className="text-xl font-semibold text-gray-900">{t('errors.title')}</h2>
        <p className="text-sm text-gray-600 mt-2">{t('errors.description')}</p>
        <div className="mt-4 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={onReset}
            className="rounded-md bg-amber-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-amber-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600 min-h-[44px] min-w-[44px]"
          >
            {t('errors.tryAgain')}
          </button>
          <button
            type="button"
            onClick={() => navigate('/catalog')}
            className="rounded-md bg-white px-4 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 min-h-[44px] min-w-[44px]"
          >
            {t('errors.goToCatalog')}
          </button>
        </div>
      </div>
    </div>
  );
}
